// import React, { useEffect } from "react";
import styles from "../Home/Home.module.css";
import { Link, useLocation } from "react-router-dom";
import PreloadImage from "../../components/PreloadImage";
import HomeTabsSection from "../../components/HomeTabs/hometabs";
import Reviews from "../../components/ClutchReviews/ClutchReviews";
import { useEffect } from "react";
import HomeFaqs from "../../components/HomeFaqs/homeFaqs";
import Animations from "../../components/Animations/animations";
import MetaTags from "../../components/MetaTags";

const Home = () => {
  
  const location = useLocation();

  useEffect(() => {
    const scrollToSection = () => {
      const hash = location.hash; // Get the hash from the URL
      if (hash) {
        const scrollToElement = () => {
          const element = document.querySelector(hash); // Find the element by ID
          if (element) {
            element.scrollIntoView({ behavior: "smooth" }); // Smooth scroll to the element
          }
        };

        // Use a small delay to ensure the DOM is fully rendered
        setTimeout(scrollToElement, 100);
      }
    };

    scrollToSection(); // Call it once when the component mounts

    // Re-run the effect whenever location changes
  }, [location]);



  const bannerPoints = [
    "Creating custom delivery solutions is our expertise.",
    "MVP of your custom delivery solution created in 30 days",
    "Combined 10+ years of experience building delivery solutions",
    "We use scalable technology for future growth",
    "Delivering custom solutions since 2019",
  ];

  const pricePoints = [
    "Get 160 hours of development and design work.",
    "Carry over any unused hours into your next month",
    "Free Meetings and Consultations with developers included",
    "Full transparency on project progress",
    "Cancel at any time!",
  ];
  const workingFlowTabs = [
    { heading: "Consultation & Planning", paragraph: "Book a call to discuss your project requirements and goals." },
    { heading: "Custom Solution Design", paragraph: "If your scope aligns with our expertise, we’ll onboard you with our team and give you an estimated timeline." },
    { heading: "Finalizing and Purchase", paragraph: "Once you’re satisfied and goals have been aligned, we start working on your project as soon as you purchase our package." },
    { heading: "Development & Support", paragraph: "Once the work begins, you’ll be assigned a project manager who will make sure your project stays true to your vision." },
    { heading: "Communication and Updates", paragraph: "You will be given access to your own Slack channel and Clickup space for constant updates and communication during the project." },
  ];
  const workingFlowContent = [
    { src: "assets/Consultation-Planning.webp", alt: "Consultation & Planning"},
    { src: "assets/custom-solution-design.webp", alt: "Custom Solution Design"},
    { src: "assets/finalizing-purchase.webp", alt: "Finalizing and Purchase"},
    { src: "assets/dev-support.webp", alt: "Development & Support"},
    { src: "assets/updates.webp", alt: "Communication and Updates"},
  ];

  const whoItForTabs = [
    { heading: "Business Owners", paragraph: "Who need a custom delivery platform, fast." },
    { heading: "Delivery-Based Startups", paragraph: "Looking to launch with a reliable system." },
    { heading: "Retailers & E-commerce Brands", paragraph: "Needing scalable logistics solutions." },
    { heading: "Multi-Vendor Marketplaces", paragraph: "That require efficient vendor management and fulfillment." },
    { heading: "On-Demand Service Providers", paragraph: "Seeking customized, client-focused delivery systems." },
  ];
  const whoItForContent = [
    { src: "assets/who-it-for-img-1.webp", alt: "Business Owners"},
    { src: "assets/who-it-for-img-2.webp", alt: "Delivery-Based Startups"},
    { src: "assets/who-it-for-img-3.webp", alt: "Retailers & E-commerce Brands"},
    { src: "assets/Multi-Vendor-Marketplaces.webp", alt: "Multi-Vendor Marketplaces"},
    { src: "assets/who-it-for-img-5.webp", alt: "On-Demand Service Providers"},
  ];
  return (
    <>
     <MetaTags
     title="Fast & Custom Delivery Solutions for Business | Ninjas Code"
     description="Launch your delivery platform in a month with Ninjas Code. Get scalable, custom solutions tailored to your business needs. Book a consultation today!"
     />
    <main>
      <section className={styles.homeBannerSec}>
        <div className={styles.container}>
          <div className={styles.homeBannerSec__text}>
          <Animations animationType="fadeInUp" threshold={0.2}>
            <h1>
              We Create Custom
              <br />
              <span className={styles.highlighted_text}>
                <span style={{ color: "#FAA916" }}>Delivery</span>{" "}
                <span style={{ color: "#fff" }}>Solutions</span>
              </span>
              <br />
              in
              <span style={{ color: "#6874E8", fontWeight: 700 }}>
                {" "}
                30 Days
              </span>
            </h1>
            </Animations>
            <Animations animationType="fadeInUp" threshold={0.2}>
            <p className={styles.subText}>
              At Ninjas Code, we specialize in building fast, reliable delivery
              software for your business needs—ready to launch in just one
              month.
            </p>
            </Animations>
            <div className={styles.homeBannerSec__points}>
              {bannerPoints.map((point, index) => (
                
                <div key={index}>
                  <Animations animationType="fadeInUp" threshold={0.2}>
                  <img
                    src="assets/checkmark.webp"
                    width="16"
                    height="16"
                    alt="checkmark"
                    loading="lazy"
                  />
                  <p>{point}</p>
                  </Animations>
                </div>
               
              ))}
            </div>
            <Animations animationType="fadeInUp" threshold={0.2}>
            <Link to="/contact" className={styles.homeBannerSec__cta}>
            Get a Quote
              <img
                src="assets/right-arrow.webp"
                width="11"
                height="11"
                alt="arrow"
                loading="lazy"
              />
           </Link>
            </Animations>
          </div>

          <div className={styles.homeBannerSec__img}>
            <div>
              <PreloadImage
                src="assets/home-banner-img.webp"
                alt="Coding"
                width="1260"
                height="100%"
  
              />
            </div>
          </div>
        </div>
      </section>

      <section className={styles.trustedBySec}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}><h2>Trusted By Companies Worldwide</h2> </Animations>
        <Animations animationType="zoomIn" threshold={0.2}>
          <div className={styles.clientsLogo}>
            
            <div>
              <img
                src="assets/yalla-logo.webp"
                alt="yalla"
                width="311"
                height="100%"
                loading="lazy"
              />
            </div>
            <div>
              <img
                src="assets/snapDelivered.webp"
                alt="snap Delivered"
                width="60%"
                height="100%"
                loading="lazy"
              />
            </div>
            <div>
              <img
                src="assets/groove.webp"
                alt="groove packer"
                width="50%"
                height="100%"
                loading="lazy"
              />
            </div>

            <div>
              <img
                src="assets/Borku-logo.webp"
                alt="Borku"
                width="50%"
                height="100%"
                loading="lazy"
              />
            </div>
            <div>
              <img
                src="assets/vinifynd.webp"
                alt="vinifynd"
                width="60%"
                height="100%"
                loading="lazy"
              />
            </div>
          </div>
          </Animations>
        </div>
      </section>

      <section className={styles.workingFlowSec}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}><h2>How Does it Work?</h2></Animations>

          <HomeTabsSection
            id="workingFlow"
            homeTabs={workingFlowTabs}
            content={workingFlowContent}
          />
     
        </div>
      </section>

      <section className={styles.specialitiesSec} id="specialities">
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}><h2>Our Specialties</h2> </Animations>
        <Animations animationType="fadeInUp" threshold={0.2}><p className={styles.subText}>
          Ninjas Code is dedicated to bringing rapid, high-quality delivery solutions to businesses of all sizes. From local on-demand services to large-scale multi-vendor platforms, our expertise ensures your project is delivered on time, while being fully functional.
          </p></Animations>
          
          <div className={styles.specialitiesSec__cards}>
          <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.specialitiesSec__cardInner}>
              <div className={styles.specialitiesSec__cardImg}>
                <img
                  src="assets/specialities-img-1.webp"
                  alt="specialities"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.specialitiesSec__cardText}>
                <div>
                <Link to="/payment-gateways-management"> <h6>Payment Gateways Management</h6></Link>
                <p>
                Seamless integration of local and global payment gateways for secure and efficient transactions.
                </p>
                </div>
                
                <Link to="/payment-gateways-management">
                See More
                  <img
                    src="assets/right-arrow-dark.webp"
                    width="16"
                    height="11"
                    alt="arrow"
                    loading="lazy"/>
                </Link>
              </div>
            </div>
            </Animations>
            <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.specialitiesSec__cardInner}>
              <div className={styles.specialitiesSec__cardImg}>
                <img
                  src="assets/specialities-img-2.webp"
                  alt="specialities"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.specialitiesSec__cardText}>
                <div>
                <Link to="/fleet-management"><h6>Fleet Management</h6></Link>
                <p>
                Advanced tools to help track and manage your delivery fleet in real-time.
                </p>
                </div>
                
                <Link to="/fleet-management">
                See More
                  <img
                    src="assets/right-arrow-dark.webp"
                    width="16"
                    height="11"
                    alt="arrow"
                    loading="lazy"/>
                </Link>
              </div>
            </div>
            </Animations>
            <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.specialitiesSec__cardInner}>
              <div className={styles.specialitiesSec__cardImg}>
                <img
                  src="assets/specialities-img-3.webp"
                  alt="specialities"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.specialitiesSec__cardText}>
                <div>
                <Link to="/multivendor-ecommerce-solutions"><h6>Multivendor E-commerce Solutions</h6></Link>
                <p>
                Scalable platforms to support multiple vendors, built for small to large scale operations.
                </p>
                </div>
                
                <Link to="/multivendor-ecommerce-solutions">
                See More
                  <img
                    src="assets/right-arrow-dark.webp"
                    width="16"
                    height="11"
                    alt="arrow"
                    loading="lazy"/>
                </Link>
              </div>
            </div>
            </Animations>

            <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.specialitiesSec__cardInner}>
              <div className={styles.specialitiesSec__cardImg}>
                <img
                  src="assets/Analytics and Reporting.webp"
                  alt="specialities"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.specialitiesSec__cardText}>
                <div>
                <Link to="/analytics-and-reporting"><h6>Analytics and Reporting</h6></Link>
                <p>
                Actionable insights and detailed reporting to monitor performance and drive data-backed decisions.
                </p>
                </div>
                
                <Link to="/analytics-and-reporting">
                See More
                  <img
                    src="assets/right-arrow-dark.webp"
                    width="16"
                    height="11"
                    alt="arrow"
                    loading="lazy"/>
                </Link>
              </div>
            </div>
            </Animations>

            <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.specialitiesSec__cardInner}>
              <div className={styles.specialitiesSec__cardImg}>
                <img
                  src="assets/Role Management.webp"
                  alt="specialities"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.specialitiesSec__cardText}>
                <div>
                <Link to="/role-management"><h6>Role Management</h6></Link>
                <p>
                Customized role-based access to ensure secure and accessible operations for admins, vendors and staff.
                </p>
                </div>
                
                <Link to="/role-management">
                See More
                  <img
                    src="assets/right-arrow-dark.webp"
                    width="16"
                    height="11"
                    alt="arrow"
                    loading="lazy"/>
                </Link>
              </div>
            </div>
            </Animations>

            <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.specialitiesSec__cardInner}>
              <div className={styles.specialitiesSec__cardImg}>
                <img
                  src="assets/Interdevice Communications Management.webp"
                  alt="specialities"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.specialitiesSec__cardText}>
                <div>
                <Link to="/interdevice-communications-management"><h6>Interdevice Communications Management</h6></Link>
                <p>
                Reliable connectivity between devices for uninterrupted communication and coordination.
                </p>
                </div>
                
                <Link to="/interdevice-communications-management">
                See More
                  <img
                    src="assets/right-arrow-dark.webp"
                    width="16"
                    height="11"
                    alt="arrow"
                    loading="lazy"/>
                </Link>
              </div>
            </div>
            </Animations>
          </div>
        </div>
      </section>

      <section className={styles.caseStudiesSec}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}>
          <h2>
            Check Out Our <span style={{ color: "#6874E8" }}>Case Studies</span>
          </h2>
          </Animations>
          <Animations animationType="fadeInUp" threshold={0.2}>
          <p className={styles.subText}>
            Take a closer look at how we’ve helped clients turn their ideas into
            reality
          </p>
          </Animations>
          <div className={styles.caseStudiesSec__cards}>
          <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.caseStudiesSec__cardInner}>
              <div className={styles.caseStudiesSec__cardImg}>
                <img
                  src="assets/borku-2.webp"
                  alt="Borku"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.caseStudiesSec__cardText}>
              <Link to="/borku"><h6>Borku</h6></Link>
                <p>
                A food delivery platform designed to promote African cuisine.
                </p>
                
                <Link to="/borku">
                  <img
                    src="assets/purple-arrow.webp"
                    width="20"
                    height="20"
                    alt="arrow"
                  />
                  View Case Study
                </Link>
              </div>
            </div>
            </Animations>
            <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.caseStudiesSec__cardInner}>
              <div className={styles.caseStudiesSec__cardImg}>
                <img
                  src="assets/yalla-app.webp"
                  alt="Yalla"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.caseStudiesSec__cardText}>
              <Link to="/yalla"><h6>Yalla</h6></Link>
                <p>
                A localized solution for on-demand food and grocery
                </p>
                <Link to="/yalla">
                  <img
                    src="assets/purple-arrow.webp"
                    width="20"
                    height="20"
                    alt="arrow"
                    loading="lazy"
                  />
                  View Case Study
                </Link>
              </div>
            </div>
            </Animations>
            <Animations animationType="zoomIn" threshold={0.2}>
            <div className={styles.caseStudiesSec__cardInner}>
              <div className={styles.caseStudiesSec__cardImg}>
                <img
                  src="assets/groove-packer-dashboard.webp"
                  alt="Groove Packer"
                  width="100%"
                  height="100%"
                  loading="lazy"
                />
              </div>
              <div className={styles.caseStudiesSec__cardText}>
              <Link to="/groove-packer"><h6>Groove Packer</h6></Link>
                <p>
                Inventory and order management reimagined
                </p>
                <Link to="/groove-packer">
                  <img
                    src="assets/purple-arrow.webp"
                    width="20"
                    height="20"
                    alt="arrow"
                  />
                  View Case Study
                </Link>
              </div>
            </div>
            </Animations>
          </div>
        </div>
      </section>

      <section className={styles.whoItForSec}>
        <div className={styles.container}>
     
          <HomeTabsSection
            id="whoItForSec"
            homeTabs={whoItForTabs}
            content={whoItForContent}
          />
        
        </div>
      </section>

      <section className={styles.reviewSec}>
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}>
          <h2>Check Out Our Testimonials</h2>
          </Animations>
          <Animations animationType="fadeInUp" threshold={0.2}>
          <p className={styles.subText}>
            See how we’ve helped clients succeed and their feedback
          </p>
          </Animations>
          {/* <div className={styles.reviewsFigure}>
            <img
              src="assets/clutch-figures.webp"
              width="375"
              height="100%"
              alt="clutch Reviews"
              loading="lazy"
            />
          </div>
          <div className={styles.reviewsImg}>
             <img
              src="assets/clutch-review-1.webp"
              width="1170"
              height="100%"
              alt="clutch Reviews"
              loading="lazy"
            />
           
          </div> */}
          <Animations animationType="zoomIn" threshold={0.2}>
          <Reviews/>
          </Animations>
        </div>
      </section>

      <section className={styles.priceSec} id="pricing">
        <div className={styles.container}>
        <Animations animationType="fadeInUp" threshold={0.2}>
          <h2>Transparent and Simple Pricing</h2>
          </Animations>
          <Animations animationType="fadeInUp" threshold={0.2}>
          <p className={styles.subText}>
            Get an entire month’s worth of development work done for a single
            unbeatable price.
          </p>
          </Animations>

          <Animations animationType="zoomIn" threshold={0.2}>
          <div
            className={styles.priceSecInner}
          >
            <div className={styles.priceSecLeft}>
              <h3>Benefits</h3>
              <div className={styles.priceSecPoints}>
                {pricePoints.map((point, index) => (
                  <div key={index} className={styles.priceModalPoints}>
                    <img
                      loading="lazy"
                      src="assets/checkmark-white.webp"
                      alt="check mark"
                      width="18"
                      height="18"
                    
                    />
                    <p>{point}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.priceSecRight}>
              <div className={styles.offTag}>
              <p>Get <strong>70%</strong> refund if unsatisfied after 1 month</p>
              </div>
              <h4>
                Unlock a Month of Development Magic for One Unbeatable Price!
              </h4>
              <p>
                Get a whole month’s worth of development work completed for one
                unbeatable price!
              </p>
              <div className={styles.priceSecCost}>
                $4,997
                <p>160 hours, Lifetime</p>
              </div>
              <Link to="/contact" className={styles.priceSec__cta}>Get a Quote
                <img
                  src="assets/right-arrow.webp"
                  width="11"
                  height="11"
                  alt="arrow"
                  loading="lazy"
                />
              </Link>

              <div className={styles.buyArrowText}>
                <div>
                  <img
                    loading="lazy"
                    src="assets/try-it-now.webp"
                    width="100"
                    height="100%"
                    alt="try it now"
                  />
                </div>
                <div className={styles.arrowImg}>
                  <img
                    loading="lazy"
                    src="https://enatega.com/wp-content/uploads/2024/10/purple-arrow.webp"
                    width="60"
                    height="100%"
                    alt="arrow"
                  />
                </div>
              </div>
            </div>
          </div>
          </Animations>
        </div>
      </section>

      <HomeFaqs/>

     
    </main>
    </>
  );
};

export default Home;
